<template>
  <div class="d-none">
  </div>
</template>
<script>
export default {
  name: "Empty",
  props: {},
  components: {},
  mixins: [
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
</style>
